import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import incident_manager from '../api/incident';
import {loadCauses} from '../api/causes';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import MaterialTable, {MTableBodyRow} from 'material-table';
import { hasExactPrivilege, hasPrivileges } from '../util/auth';
import { LinkTwoTone, Videocam, Photo, VolumeUp } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SyncIcon from '@material-ui/icons/Sync';
import { buildMediaObject, mediaExtensions } from '../util/media';
import { Button, Chip, CircularProgress, Collapse, IconButton, TextField, Tooltip } from '@material-ui/core';

export default function Incidents(props){
    var [incidents, setIncidents] = useState(null);
    var [message, setMessage] = useState(null);
    var [teamMode, setTeamMode] = useState(props&&props.teamMode?props.teamMode:false);
    var [loadingIncidents, setLoadingIncidents] = useState(false);
    var [tableFilters, setTableFilters] = useState({});
    var [raceNameSearch, setRaceNameSearch] = useState('');
    var [yearSearch, setYearSearch] = useState('');
    var [riderNameSearch, setRiderNameSearch] = useState('');
    var [riderNameFilters, setRiderNameFilters] = useState([]);
    var [advancedSearchParams, setAdvancedSearchParams] = useState({});
    var [detailedSearchOpen, setDetailedSearchOpen] = useState(false);

    var [causes, setCauses] = useState([])

	// race_edition_uci_race_category => ME/WE category 
	
    const applySavedFilter = column => {
        if (Object.prototype.hasOwnProperty.call(tableFilters, column.field)) {
            return { ...column, defaultFilter: tableFilters[column.field] };
        }
        return column;
    };

    const columns = [
        { title: 'Incident ID', field: 'incident_id'},
        { title: 'Race name', field: 'racename'},
        { title: 'Category', field: 'category'},
        { title: 'Stage', field: 'stage_id'},
        { title: 'Incident time', field: 'incident_ts', defaultSort: 'desc', customSort: (a,b) => Date.parse(a.incident_ts)-Date.parse(b.incident_ts)},
        { title: 'Type', field: 'type', lookup: { 'CRASH': 'CRASH', 'NO CRASH': 'NO CRASH'}},
        { title: 'Km to finish', field: 'incident_km_from_finish'},
        { 
            title: 'causes', 
            field: 'causes',
            lookup: causes.reduce((acc, cause) => { 
                acc[cause.cause_id] = cause.cause_description; 
                return acc; 
            }, {}),
            render: rowData => {
                const causesMapped = (Array.isArray(rowData.causes) ? rowData.causes : [])
                    .map(causeIdx => causes.find(c => c.cause_id === causeIdx)?.cause_description)
                    .filter(Boolean);

                return causesMapped.length === 0 ? (<span>0</span>) : (
                    <Tooltip
                        title={<div style={{ whiteSpace: 'pre-line' }}>{causesMapped.join('\n')}</div>}
                        arrow
                    >
                        <span>{causesMapped.length}</span>
                    </Tooltip>
                );
            },
            customFilterAndSearch: (term, rowData) => {
                if (!term || term.length === 0) return true;
                return term.some(t => rowData.causes?.includes(parseInt(t)));
            },
        },
        { title: 'Severity (0-10)', field: 'incident_severity'
        },
        { 
            title: '# involved riders', 
            field: 'incident_involved_riders',
            customFilterAndSearch: (term, rowData) => {
                if (term === '') return true;
                const exactMatch = true;
                return exactMatch 
                    ? String(rowData.incident_involved_riders) === String(term) 
                    : String(rowData.incident_involved_riders).includes(String(term));
            },
        }, 
        { title: 'Media', field: 'incident_media'}, 			
        { title: 'Analyst status', field: 'incident_analysis_status', lookup: { 'Complete': 'Complete', 'Pending': 'Pending'}},
        { title: 'Actions', field: 'incident_actions'}
    ].map(applySavedFilter);

    /*
    if (hasPrivileges('admin')) columns.splice(columns.length - 1, 0, { 
        title: 'Analyst status', 
        field: 'incident_analysis_status', 
        lookup: { 'Complete': 'Complete', 'Pending': 'Pending'},
    });
    */

    const confirmDialog = incident_id => {
        confirmAlert({
          title: 'Confirm to submit',
          message: 'Are you sure you want to delete the incident '+incident_id+"?",
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                  incident_manager.remove_incident({'incident_id': incident_id}).then((res)=>{
                      setMessage("Successfully removed incident "+incident_id);
                      teamMode?load_team_incidents():load_incidents();
                  })
              }
            },
            {
              label: 'No',
              onClick: () =>{
                  setMessage("");
              }
            }
          ]
        });
      };
    
    const getDraftRiderNameFilters = () => {
        const riderName = riderNameSearch.trim();
        if (riderName === '' || riderNameFilters.includes(riderName)) return riderNameFilters;
        return [...riderNameFilters, riderName];
    };

    const buildAdvancedSearchParams = (riders = getDraftRiderNameFilters()) => {
        const params = {};
        const raceName = raceNameSearch.trim();
        const year = yearSearch.trim();

        if (raceName !== '') params.race_name = raceName;
        if (year !== '') params.year = year;
        if (riders.length > 0) params.rider_names = riders;

        return params;
    };

    const addRiderNameFilter = () => {
        const riderName = riderNameSearch.trim();
        if (riderName === '') return;

        setRiderNameFilters((currentFilters) => {
            if (currentFilters.includes(riderName)) return currentFilters;
            return [...currentFilters, riderName];
        });
        setRiderNameSearch('');
    };

    const removeRiderNameFilter = (riderName) => {
        setRiderNameFilters((currentFilters) => currentFilters.filter((name) => name !== riderName));
    };

    const applyAdvancedSearch = () => {
        const riderFilters = getDraftRiderNameFilters();
        const params = buildAdvancedSearchParams(riderFilters);
        setRiderNameFilters(riderFilters);
        setRiderNameSearch('');
        setAdvancedSearchParams(params);
        return teamMode ? load_team_incidents(params) : load_incidents(params);
    };

    const clearAdvancedSearch = () => {
        setRaceNameSearch('');
        setYearSearch('');
        setRiderNameSearch('');
        setRiderNameFilters([]);
        setAdvancedSearchParams({});
        return teamMode ? load_team_incidents({}) : load_incidents({});
    };

    let load_incidents = (params = advancedSearchParams) => {
        setLoadingIncidents(true);
        return incident_manager.get_incidents(params).then((response) =>{
            var incident_rows = []
			
            Object.values(response).forEach((incident)=>{
                const icons = [];
                if ('media' in incident && incident['media'] != null) {
                    const mediaObject = buildMediaObject(incident['media'].split(',')
                        .map(x => ({ incident_media_url: x, incident_media_id: -1 })), false, true);

                    const iconCombination = { 'video': <Videocam />, 'audio': <VolumeUp />, 'image': <Photo />, 'link': <LinkTwoTone />, 'pdf': <LinkTwoTone /> };
                    Object.keys(mediaExtensions).forEach(ext => {
                        if (mediaObject[ext].length > 0) {
                            icons.push(iconCombination[ext]);
                        }
                    });
                }

                let analysis_action = '';
                if (incident['incident_require_analyst']) {
                    analysis_action = incident['incident_analysis_complete']
                        ? 'Complete'
                        : 'Pending';
                }

				incident_rows.push({
                    incident_id: incident['incident_id'],
                    racename: incident["race_name"],
					category: incident["race_edition_uci_race_category"],
					type: incident["incident_type"],
                    incident_ts: incident['incident_timestamp'],
					incident_km_from_finish: incident["incident_km_from_finish"],
                    incident_severity: incident['incident_severity'],
                    incident_involved_riders: incident["involved_riders"],
                    incident_num_causes: incident["incident_causes"],
                    incident_require_analyst: incident["incident_require_analyst"],
					stage_id: incident["race_stage_index"],
                    causes: incident['causes'],
					incident_media: <div>{icons}</div>,
                    incident_actions: <div className='incident-actions'><Link className='btn btn-theme' to={`/incident/${incident['incident_id']}`}>View</Link>{hasPrivileges("commissaire")?<span className='btn btn-danger' onClick={()=>confirmDialog(incident.incident_id)}>Delete</span>:""}</div>,
                    incident_analysis_status: analysis_action,
                })

            })
			setIncidents(incident_rows);
        }).finally(() => {
            setLoadingIncidents(false);
        });
    }

    let load_team_incidents = (params = advancedSearchParams) => {
        setLoadingIncidents(true);
        return incident_manager.get_team_incidents(params).then((response) =>{
            var incident_rows = []
            Object.values(response).forEach((incident)=>{
                incident_rows.push({
                    incident_id: incident['incident_id'],
                    racename: incident["race_name"],					
					category: incident["race_edition_uci_race_category"],
					type: incident["incident_type"],
                    incident_ts: incident['incident_timestamp'],
					incident_km_from_finish: incident["incident_km_from_finish"],
                    incident_severity: incident['incident_severity'],
                    incident_involved_riders: incident["involved_riders"],
                    incident_num_causes: incident["incident_causes"],
					stage_id: incident["race_stage_index"],
                    causes: incident['causes'],					
					incident_media: incident["incident_media"],
                    incident_actions: <div className='incident-actions'><Link className='btn btn-theme' to={`/incident/${incident['incident_id']}`}>View</Link>{hasPrivileges("commissaire")?<span className='btn btn-danger' onClick={()=>confirmDialog(incident.incident_id)}>Delete</span>:""}</div>,
                })
            })
            setIncidents(incident_rows);
        }).finally(() => {
            setLoadingIncidents(false);
        });
    }

    const refreshIncidents = () => {
        return teamMode ? load_team_incidents(advancedSearchParams) : load_incidents(advancedSearchParams);
    };

    let load_causes = () =>{
        loadCauses().then((response)=>{
            setCauses(response)
        })
    }

    useEffect(()=>{
        teamMode?load_team_incidents():load_incidents();
        load_causes();
    }, [teamMode]);

    if (incidents) {
        return (
            <div>
                <h1>Incidents</h1>
                <span>{message}</span>
                <span className='filter-team'>
                    {hasExactPrivilege('staff')?<span class="badge">{teamMode?"You're currently viewing your team's incidents only.":"You're currently viewing all incidents"}</span>:""}
                    {hasExactPrivilege('staff')?<button className={`btn btn-${teamMode?"warning":"success"}`} onClick={()=>setTeamMode(!teamMode)}>{teamMode?"Show all incidents":"Show my team's incidents only"}</button>:""}
                </span>

                <div className="incident-detailed-search">
                    <button
                        className="incident-detailed-search-toggle"
                        type="button"
                        aria-expanded={detailedSearchOpen}
                        onClick={() => setDetailedSearchOpen(!detailedSearchOpen)}
                    >
                        <span>Detailed search</span>
                        <ExpandMoreIcon className={detailedSearchOpen ? 'incident-detailed-search-icon open' : 'incident-detailed-search-icon'} />
                    </button>
                    <Collapse in={detailedSearchOpen}>
                        <div className="incident-advanced-search">
                            <TextField
                                label="Race name"
                                value={raceNameSearch}
                                onChange={(event) => setRaceNameSearch(event.target.value)}
                                variant="outlined"
                                size="small"
                            />
                            <TextField
                                label="Year"
                                value={yearSearch}
                                onChange={(event) => setYearSearch(event.target.value)}
                                variant="outlined"
                                size="small"
                                type="number"
                            />
                            <div className="incident-rider-search">
                                <TextField
                                    label="Rider name"
                                    value={riderNameSearch}
                                    onChange={(event) => setRiderNameSearch(event.target.value)}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            addRiderNameFilter();
                                        }
                                    }}
                                    variant="outlined"
                                    size="small"
                                />
                                <Tooltip title="Add rider name" arrow>
                                    <span>
                                        <IconButton
                                            aria-label="Add rider name"
                                            onClick={addRiderNameFilter}
                                            size="small"
                                        >
                                            <AddIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </div>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={applyAdvancedSearch}
                                disabled={loadingIncidents}
                            >
                                Search
                            </Button>
                            <Button
                                variant="text"
                                color="default"
                                onClick={clearAdvancedSearch}
                                disabled={loadingIncidents}
                            >
                                Reset
                            </Button>
                            {riderNameFilters.length > 0 && (
                                <div className="incident-rider-filters">
                                    {riderNameFilters.map((riderName) => (
                                        <Chip
                                            key={riderName}
                                            label={riderName}
                                            onDelete={() => removeRiderNameFilter(riderName)}
                                            deleteIcon={<CloseIcon />}
                                            size="small"
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    </Collapse>
                </div>

                <MaterialTable
                    title={null}
                    columns={columns}
                    data={incidents}
                    options={{
                        filtering: true,
                        paging: true,
                        pageSize: 20,
                        pageSizeOptions: [20, 50, 100],
                        sorting: true,
                        search: false,
                        debounceInterval: 1000
                    }}
                    onFilterChange={(filters) => {
                        setTableFilters(filters.reduce((acc, filter) => {
                            acc[filter.column.field] = filter.value;
                            return acc;
                        }, {}));
                    }}
                    components={{
                        Row: props => <MTableBodyRow {...props}/>,
                        Toolbar: props => {
                            const filteredIncidentCount = props.dataManager?.filteredData.length ?? incidents.length;
                            const incidentLabel = filteredIncidentCount === 1 ? 'incident' : 'incidents';

                            return (
                                <div className="incident-table-toolbar">
                                    <div className="incident-result-count">
                                        Showing {filteredIncidentCount} of {incidents.length} {incidentLabel}
                                    </div>
                                    <Tooltip title="Refresh incidents" arrow>
                                        <span>
                                            <IconButton
                                                aria-label="Refresh incidents"
                                                onClick={refreshIncidents}
                                                disabled={loadingIncidents}
                                                size="small"
                                            >
                                                {loadingIncidents ? (
                                                    <CircularProgress size={20} />
                                                ) : (
                                                    <SyncIcon />
                                                )}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </div>
                            );
                        }
                    }}
                />
            </div>
        )
    }
    else{
        return (<div><h1>Incidents</h1><p>Loading incidents...</p></div>)
    }
}
